import { Box, Flex, Text } from '@chakra-ui/react'
import { DDSTheme } from '@ds/index'
import { ddsTokens } from '@ds/index'

type LegendContentProps = {
	payload?: Array<{
		value: string
		type?: string
		color: string
	}>
	wrapperStyle?: React.CSSProperties
}

const LegendContent = ({ payload, wrapperStyle }: LegendContentProps) => {
	const tokens = ddsTokens[DDSTheme.light]

	if (!payload || payload.length === 0) return null

	// Filter out items with legendType="none"
	const visibleItems = payload.filter((entry) => entry.type !== 'none')

	if (visibleItems.length === 0) return null

	return (
		<Flex
			justify="center"
			align="center"
			mt={2}
			gap={4}
			flexWrap="wrap"
			style={wrapperStyle}
		>
			{visibleItems.map((entry, index) => (
				<Flex key={`legend-item-${index}`} align="center" gap={2}>
					<Box
						width="10px"
						height="10px"
						backgroundColor={entry.color}
						borderRadius="sm"
					/>
					<Text fontSize="xs" color={tokens.primitive.light.gray[800]}>
						{entry.value}
					</Text>
				</Flex>
			))}
		</Flex>
	)
}

export default LegendContent
